import {PublishSetupModule} from './tokenBuild'

export const functionPublish = (client, Data, installation, device) => {
    //   client.publish(`${installation}/App`, PublishSetupModule.GetJson((JSON.stringify({
    //     Data,
    //     "Token": Math.floor(Math.random() * (999999999 - 100000000 + 1) + 100000000)
    // }), device.Name, device.Type, device.Version))
    client.publish(`${installation}/App`, PublishSetupModule(JSON.stringify({
     Data,
      "Token": Math.floor(Math.random() * (999999999 - 100000000 + 1) + 100000000)
    }), device.Name, device.Type, device.Version))
    console.log(`${installation}/App`, PublishSetupModule(JSON.stringify({
      Data,
       "Token": Math.floor(Math.random() * (999999999 - 100000000 + 1) + 100000000)
     }), device.Name, device.Type, device.Version))
  }